import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import { Avatar, AvatarProps, Tooltip } from '@mui/material';
import { useMemo } from 'react';
import { UserInfo } from '../../../sic-lib/types/UserConfig';
import { getUserAvatarData } from '../../../sic-lib/utils/userHelpers';

type Props = AvatarProps & {
    user?: UserInfo;
    userName?: string; //required with users. leaving blank will make rendering deleted users awkward
    users?: UserInfo[];
    tooltip?: boolean;
    scale?: number;
};

export function UserAvatar({
    user,
    userName,
    users,
    tooltip = true,
    scale = 2.5,
    ...props
}: Props) {
    const avatarData = useMemo(
        () => getUserAvatarData(user, users, userName),
        [user, users, userName],
    );

    return (
        <Tooltip
            title={
                tooltip === false ? undefined : avatarData?.tooltip || `Deleted User: ${userName}`
            }
            enterDelay={500}
            leaveDelay={200}
        >
            <Avatar
                sx={{
                    background: avatarData?.background,
                    width: `${scale}rem`,
                    height: `${scale}rem`,
                    fontSize: `${scale * 0.5}rem`,
                }}
                {...props}
            >
                {avatarData?.initials}
                {!avatarData?.initials && <PersonRemoveIcon />}
            </Avatar>
        </Tooltip>
    );
}
